import {withNamespaces, WithNamespaces} from 'react-i18next'
import {BannerContainer} from './components/BannerContainer'
import {BannerText} from './components/BannerText'
import messages from '../../../../../../../assets/messages'
import {BannerLink} from './components/BannerLink'

type InvestSelfBannerProps = {
  pammManagerAccountId: string
} & WithNamespaces

const _InvestSelfBanner = ({pammManagerAccountId, t}: InvestSelfBannerProps) => (
  <BannerContainer>
    <BannerText>{t(messages.investSelfBannerText.i18nKey)}</BannerText>
    <BannerLink href={`/transactions/${pammManagerAccountId}/deposit`}>
      {t(messages.depositNow.i18nKey)}
    </BannerLink>
  </BannerContainer>
)

export const InvestSelfBanner = withNamespaces()(_InvestSelfBanner)
